import { logger } from "@/utils/logger";
import { DealerManager } from './dealerManager';

export const openTradeForm = async (language: 'en' | 'fr') => {
  // Check if TradeBoost is enabled for this dealer
  const isTradeBoostEnabled = DealerManager.isTradeBoostEnabled();
  
  if (isTradeBoostEnabled) {
    const $ = (window as any).$;
    if ($) {
      try {
        const tradeContainer = $('#TradeInBarPopupContainer');
        if (tradeContainer.length > 0) {
          // Try different approaches to open the popup
          if (typeof tradeContainer.popupize === 'function') {
            const popupized = tradeContainer.popupize();
            
            // Check if setTrigger method exists
            if (typeof popupized.setTrigger === 'function') {
              popupized.setTrigger();
            }
            if (typeof popupized.open === 'function') {
              popupized.open();
            } else {
              // Fallback: try click trigger directly
              tradeContainer.trigger('click');
            }
          } else {
            // Fallback: try click trigger directly
            tradeContainer.trigger('click');
          }
          return; // Successfully opened TradeBoost
        }
      } catch (error) {
        console.error('Error opening TradeBoost:', error);
      }
    }
  }
  
  // Fallback: Redirect to trade-in page based on language
  logger.log('⏳ Adding delay before external redirect to prevent session corruption...');
  await new Promise(resolve => setTimeout(resolve, 200));
  
  const redirectUrl = language === 'fr' 
    ? '/demandes/vehicule-echange-occasion.html'
    : '/requests/trade-in-used.html';
  
  logger.log('🔗 Redirecting to:', redirectUrl);
  window.location.href = redirectUrl;
};
